export default __webpack_public_path__ + "static/media/files.d3ca840a.svg";